import './Footer.css';

function Footer() {
  return (
    // <div className='footerContainer'>
    //   <p className='mensagemFooter'>Núcleo Técnico de Monitoramento de Contratos de Gestão com a Riosaúde</p>
    // </div>
    // <div className='main-footer'>
    //   <p className='fonte-pequena m-0'>Núcleo Técnico de Monitoramento de Contratos de Gestão com a Riosaúde</p>
    // </div>
    // <footer className='main-footer'>

    // fixed-bottom

    <footer className='footer-container d-flex justify-content-center p-1'>
      <p className='fonte-pequena m-0'>Núcleo Técnico de Monitoramento de Contratos de Gestão com a Riosaúde</p>
    </footer>
  );
}

export default Footer;
